/*
 * action types
 */
export const DRAFT = 'DRAFT'

/*
 * action creators
 */
export default function setDraft(payload) {
  return {
    payload,
    type: DRAFT,
  }
}
